import { useMutation } from "@tanstack/react-query";
import {
	AuthPayload,
	CreateOddDTO,
	OtpPayload,
} from "../../module/global.types";
import api from "../api";

export function useSignUp() {
	return useMutation({
		mutationFn: (data: AuthPayload) =>
			api
				.post("/auth/signup", data, {
					// headers: {
					//     "Content-Type": ""
					// }
				})
				.then((resp) => resp.data),
	});
}

export function useOtp(signup?: boolean) {
	return useMutation({
		mutationFn: (data: OtpPayload) =>
			api
				.get(signup ? "/user/otp/verify/signup" : "/user/otp/verify", {
					params: {
						externalUserId: data.externalUserId,
						submittedOTP: data.submittedOTP,
					},
				})
				.then((resp) => resp.data),
	});
}

export function useLogin() {
	return useMutation({
		mutationFn: (data: Pick<AuthPayload, "username" | "password">) =>
			api.post("/auth/signin", data).then((resp) => resp.data),
	});
}

export function useCreateOdds() {
	return useMutation({
		mutationFn: (data: CreateOddDTO) =>
			api
				.post("/bookingcode/create", data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => resp.data),
	});
}

export function useLikeBookingCode() {
	return useMutation({
		mutationFn: (data: Record<string, string>) =>
			api.post("/bookingcode/like", data).then((resp) => resp.data),
	});
}

export function useUnLikeBookingCode() {
	return useMutation({
		mutationFn: (data: Record<string, string>) =>
			api.post("/bookingcode/unlike", data).then((resp) => resp.data),
	});
}

export function useCopyBookinCode() {
	return useMutation({
		mutationFn: (data: Record<string, string>) =>
			api.post("/bookingcode/copy", data).then((resp) => resp.data),
	});
}

export function useLogout() {
	return useMutation({
		mutationFn: (data: Record<string, string>) =>
			api.post("/auth/logout", data).then((resp) => resp.data),
	});
}
